<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.status')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProductStatusForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProductStatusForm from '../../components/productstatus/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProductStatus';

const { mapFields } = createHelpers({
  getterType: 'productstatus/getField',
  mutationType: 'productstatus/updateField'
});

export default {
  name: 'ProductStatusCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProductStatusForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('productstatus', ['create', 'reset'])
  }
};
</script>
